const LongWarningContent = () => {
  return (
    <>
      <p>
        El cargador ha experimentado un error al enviar los datos que nos permite registrar con
        éxito esta carga en curso en nuestro sistema.
      </p>
      <p>Por lo tanto:</p>
      <ul>
        <li>No se podrán visualizar las estadísticas de la carga en curso.</li>
        <li>Esta transacción no podrá ser registrada en el historial de transacciones.</li>
      </ul>
      <p>Si necesitas más información, puedes contactarte con nuestro equipo de soporte.</p>
    </>
  );
};

export default LongWarningContent;
